import request from "@/utils/request";
import qs from "qs";

/**
 * 查询会员
 * @param params
 * @returns {*}
 */
export function getMemberList(params) {
  return request({
    url: "/user/getList",
    method: "get",
    params
  });
}

/**
 * 查询会员详情
 * @param params
 * @returns {*}
 */
export function getMemberDetail(params) {
  return request({
    url: "/user/getDetail",
    method: "get",
    params
  });
}

/**
 * 审核会员
 * @param params
 * @returns {*}
 */
export function checkRealName(params) {
  return request.post("/user/checkRealName", qs.stringify(params));
}

/**
 * 冻结-解冻会员账号
 * @param params
 * @returns {*}
 */
export function switchStatus(params) {
  return request.post("/user/switchStatus", qs.stringify(params));
}

/**
 * 新增会员
 * @param params
 * @returns {*}
 */
export function editMember(params) {
  return request.post("/user/edit", qs.stringify(params));
}

/**
 * 会员充值
 * @param params
 * @returns {*}
 */
export function rechargeMember(params) {
  return request.post("/user/recharge", qs.stringify(params));
}

/**
 * 查询会员账户余额
 * @param params
 * @returns {*}
 */
export function getUserAccount(params) {
  return request({
    url: "/user/getUserAccount",
    method: "get",
    params
  });
}

/**
 * 会员列表导出
 * @param params
 * @returns {*}
 */
export function exportUserList(params) {
  return request({
    url: "/user/exportList",
    method: "get",
    responseType: "blob", // 重要：设置responseType为'blob'以处理二进制数据
    params
  });
}

// =============== 区域代理 start ====================

/**
 * 查询区域代理列表
 * @param params
 * @returns {*}
 */
export function getRegionalList(params) {
  return request({
    url: "/userRegional/getList",
    method: "get",
    params
  });
}

/**
 * 新增区域代理
 * @param params
 * @returns {*}
 */
export function addRegional(params) {
  return request.post("/userRegional/add", qs.stringify(params));
}

/**
 * 修改代理状态
 * @param params
 * @returns {*}
 */
export function editRegionalStatus(params) {
  return request.post("/userRegional/editStatus", qs.stringify(params));
}

// =============== 区域代理 end ====================


// =============== 会员账户流水 start ====================

/**
 * 查询会员账户流水
 * @param params
 * @returns {*}
 */
export function getAcctFlow(params) {
  return request({
    url: "/user/getAcctFlow",
    method: "get",
    params
  });
}
// =============== 会员账户流水 end ====================


/**
 * 下级会员
 * @param params
 * @returns {*}
 */
export function getJuniors(params) {
  return request({
    url: "/user/getJuniors",
    method: "get",
    params
  });
}
/**
 * 查询会员的下级统计
 * @param params
 * @returns {*}
 */
export function getJuniorSummary(params) {
  return request({
    url: "/user/getJuniorSummary",
    method: "get",
    params
  });
}

/**
 * 设置代理信息
 */
export function setAgentInfo(params) {
  return request.post("/user/setAgentInfo", qs.stringify(params));
}
/**
 * 设置大区代理信息
 */
export function setRegionAgentInfo(params) {
  return request.post("/user/setRegionAgentInfo", qs.stringify(params));
}

export function getUserPerformance(params) {
  return request({
    url: "/user/getUserPerformance",
    method: "get",
    params
  });
}

// 设置用户类型
export function setUserTypeQuery(params) {
   return request.post("/user/setUserLevel", qs.stringify(params));
}

// 获取用户等级列表
export function getUserLevelList(params) {
  return request({
    url: "/userLevel/getList",
    method: "get",
    params
  });
}

// 冻结/解冻
export function switchFreeze(params) {
  return request.post("/user/switchStatus", qs.stringify(params));
}
